
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import styles from './EmployerProfilePlanUi.module.css';
import VerificationBannerForEmployerProfile from '../VerificationBannerForEmployerProfile/VerificationBannerForEmployerProfile';
import { TopRightArrow } from '../../../../assets/images/icons';


const EmployerProfilePlanUi = ({ }) => {

    const user = useSelector(state => state.user.user);
    let price = "$" + (user?.subscriptionDetail?.plan?.amount || 0) / 100
    let price_reccuring_interval = user?.subscription_price?.recurring?.interval;
    const navigate = useNavigate()
    let priceName;
    if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH || user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR) {
        priceName = t('employer_plan.Basic')
    } else if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH || user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR) {
        priceName = t('employer_plan.SME')
    } else if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_FREE_FOR_1_MONTH || user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_FREE_FOR_1_YEAR) {
        priceName = t('employer_plan.Free')
    }

    return (
        <div className={styles.planContainer}>
            <div className={styles.currentPlanHeader}>
                <p className={styles.planHeading}>{t('billing.currentPlan')}</p>

            </div>
            <div className={styles.selectedPlanContainer} >
                <div className={styles.planHeader}>
                    <div className={styles.renewal}>{priceName || t('planUI.FREE')}</div>
                    <div className={styles.month}>{price}/{price_reccuring_interval?.slice(0, 2)}</div >
                </div>
                <div className={`${styles.activeContainer} ${styles.activeLink}`}>
                    <span className={styles[user.subscriptionStatus]}>{t('employer.subscription_form.' + user.subscriptionStatus)}</span>
                </div>
            </div>
            <div className={styles.buttonWrapper}>
                <div onClick={() => {
                    navigate("/profile/billing")
                }} className={styles.seeAllButtonContainer}>
                    <p className={styles.seeAllButton}>{t(`manage_subscription`)}</p>
                    <img src={TopRightArrow} alt="arrow icon" className={styles.arrowIcon} />
                </div>
            </div>
            <VerificationBannerForEmployerProfile
                buttonTitle={t('verificationBanner.buttonTitle')}
                title={t('verificationBanner.title')}
            />

        </div>
    );
};

export default EmployerProfilePlanUi;
